import React from 'react';

import OAuthLogin from '../../components/loginpages/OAuthLogin';
import { LoginComponentProps } from '../../types/LoginFormData';
import { TSPCategory, TSPConfig, createOAuthHelpText } from '../types';
import { OAuthHandlers } from '../types';

const zubieConfig: TSPConfig = {
  key: 'zubie',
  name: 'Zubie',
  category: TSPCategory.OAUTH,

  // OAuth configuration
  oauth: {
    authUrl: 'https://login.zubiecar.com/authorize',
    requiredParams: ['client_id', 'response_type', 'state'],
    getRedirectUri: (linkState: string) =>
      `${process.env.REACT_APP_REDIRECT_URL}/zubie`,
    // Note: redirect_uri is NOT used in production for Zubie
    // Production only sends: client_id, response_type, state
    urlBuildingOptions: {
      usePreConfiguredRedirectUri: true,
    },
    // API field mappings for the onboard endpoint (uses default 'api_key' field)
    callbackOptions: {
      // Zubie doesn't need any custom field mappings - uses all defaults
    },
  },

  helpText: createOAuthHelpText('Zubie'),
  loginComponent: (
    props: LoginComponentProps,
    oAuthHandlers?: OAuthHandlers
  ) => {
    return (
      <OAuthLogin
        onDirectConnect={() => {
          oAuthHandlers?.initiateOAuth('zubie');
        }}
        tsp='zubie'
        serviceName={props.serviceName || ''}
        onValidityChange={props.onValidityChange}
      />
    );
  },
};

export default zubieConfig;
